import {useState, useEffect} from 'react'
import {parseEDNString} from 'edn-data'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import {testCode} from '../../../services/models'
import {CodeBlock} from '../../text'
import {toEdn} from '../../formatters'
import type {EndpointConfig, ModelStageProps} from './types'

const makeRequestCode = ({url, headers, body}: EndpointConfig) => {
  const headersEdn = toEdn(headers || '')
  const headersStr = headersEdn ? ':headers ' + headersEdn : ''

  const bodyEdn = toEdn(body || '')
  const bodyStr = bodyEdn ? ':json ' + bodyEdn : ''

  return `(POST "${url || ''}" {${headersStr} ${bodyStr}})`.replace('"%PROMPT%"', 'prompt')
}

const EndpointTest = ({endpoint, enableNext, onChange, onEndpointUpdate}: ModelStageProps) => {
  const [result, setResult] = useState()
  const [request, setRequest] = useState('')
  const [error, setError] = useState()

  useEffect(() => {
    const runTest = async () => {
      try {
        setResult(undefined)
        setError(undefined)
        enableNext(true)
        const res = await testCode(code, {stage: 'request'})
        onChange('request_code', code)
        onEndpointUpdate('response', res)
        const result = parseEDNString(res, {mapAs: 'object', keywordAs: 'string'}) as any
        setResult(result)
      } catch (e) {
        setError(e as any)
        enableNext(false)
      }
    }

    const code = makeRequestCode(endpoint || {})
    if (code !== request) {
      setRequest(code)
      runTest()
    }
  }, [request, enableNext, endpoint, onChange, onEndpointUpdate])

  return (
    <Box>
      {!result && !error && <CircularProgress color="secondary" size={40} />}
      {error && (
        <Box>
          <Typography variant="h5">Test failed:</Typography>
          <Typography>{error}</Typography>
        </Box>
      )}
      {result && (
        <Box>
          <Typography variant="h5">Endpoint response:</Typography>
          <CodeBlock>{JSON.stringify(result, null, 2)}</CodeBlock>
        </Box>
      )}
    </Box>
  )
}

export default EndpointTest
